export type Bonus = {
  number: string
  title: string
  /** Short title printed on the code-drawn cover. */
  short: string
  body: string
  accent: string
  /** Optional rendered cover. When empty, a code-drawn cover is shown. */
  cover?: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Only 20-Minutes Emergency Practice Picker',
    short: '20-Minute Practice Picker',
    body: 'Short on time, or caught without a plan? Answer one question about what your team needs today and the picker hands you a complete practice you can start in 20 minutes — warm-up, focus and a game, already timed.',
    accent: 'bg-coral',
    cover: 'https://cdn.magicpatterns.com/uploads/mFqabEAWQh9TJ4AuwGh3SR/mockup-the-only-20-minutes-emergency-practice-picker.png',
  },
  {
    number: '02',
    title: 'The Coach\u2019s Cue Cards',
    short: 'Coach\u2019s Cue Cards',
    body: 'The exact short words to say courtside for every core skill \u2014 serve, pass, set, hit, block and dig. One clear cue and the #1 error-fix per skill, so you correct in seconds and keep the rep count high instead of giving a speech.',
    accent: 'bg-indigo',
    cover: 'https://cdn.magicpatterns.com/uploads/sQ95EGstNTCe8qbi4B6zxa/mockup-the-coach-s-cue-cards.png',
  },
  {
    number: '03',
    title: 'The Gym-Bag & On-Time Card',
    short: 'Gym-Bag & On-Time Card',
    body: 'A one-card checklist of exactly what to pack, plus a 5-minute routine that gets practice started on the whistle \u2014 balls out, nets up, players moving \u2014 so you stop losing the first fifteen minutes to setup and stragglers.',
    accent: 'bg-teal',
    cover: 'https://cdn.magicpatterns.com/uploads/ffNBsk6vT5gbHiXpcwjACH/mockup-the-gym-bag-on-time-card.png',
  },
  {
    number: '04',
    title: 'The No-Lines Station Wheel',
    short: 'No-Lines Station Wheel',
    body: 'A station-rotation wheel that keeps every player touching a ball instead of standing in line. Drop your drills into the wheel, rotate on the clock, and multiply the reps in the same hour \u2014 even with a big, mixed-level group.',
    accent: 'bg-amber',
    cover: 'https://cdn.magicpatterns.com/uploads/1vymLWtSuW9hryz7GT9HE2/mockup-the-no-lines-station-wheel.png',
  },
  {
    number: '05',
    title: 'The Player Practice-at-Home Card Set',
    short: 'Practice-at-Home Cards',
    body: 'A set of printable cards your players take home to keep their reps up between practices \u2014 ball-control, serving and footwork they can do against a wall or in the yard \u2014 so your next practice doesn\u2019t start from zero.',
    accent: 'bg-coral',
    cover: 'https://cdn.magicpatterns.com/uploads/rYx1B3DgbEwDGNsuCNAmjc/mockup-the-player-practice-at-home-card-set.png',
  },
]
